<template>
  <v-menu transition="slide-y-transition">
    <template v-slot:activator="{ props }">
      <v-btn color="primary" v-bind="props" variant="flat"> Actions <v-icon end>mdi-dots-vertical</v-icon> </v-btn>
    </template>

    <v-list>
      <v-list-item @click="performAction(action)" v-for="(action, index) in actions" :key="index">
        <v-list-item-title>{{ action }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "ActionDropdown",

  props: {
    performAction: Function,
    actions: Array,
  },
};
</script>
